import { Alert, Button, FormControl, FormGroup, Modal } from "react-bootstrap";
import { useState } from "react";
import Switch from "react-switch";
import {Row} from "react-bootstrap";
import {FormLabel} from "react-bootstrap";
import UserDataService from './services/user.serviceaux'

function ModalVerifyEmail(props) { 
  const [lgShow, setLgShow] = useState(false);
  const [user, setUser] = useState(props.user);
	const [email, setEmail] = useState(props.user?props.user.email:"");

  // This is how you make the current user available on any functional component
  //const { user } = useSelector(state => state.auth);

  const handleClose = () => setLgShow(false);
  const handleShow = () => {
    setLgShow(true); 
  };

	const handleUserVerification = () => {
		// Check if user is verified
		UserDataService.get(user.id).then(response => {
			setUser(response.data[0]);
			if (response.data[0].isVerified) {
				alert("Your email is already verified.");
			} else {
				handleShow();
			}
		}).catch(e => {
			console.log("Error fetching user data:", e);
			alert("An error occurred while checking user verification status. Please try again later.");
		});
	};	

	const onchangeEmail = (e) => {
		setEmail(e.target.value);
	}

  return (
    <>
			{!user.isVerified &&			
      <Button style={{width:'100%', marginTop:'10px'}} onClick={handleUserVerification} variant="success">{"Verify your account to save your design!"}</Button>        
			}
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            {'We need you to verify your email address'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
					<FormGroup>
						<FormLabel>
							Verifying your email address allows you to save your designs and access them later.
						</FormLabel>				
					</FormGroup>

					<FormLabel>Username</FormLabel>
					<FormControl
						type="text"
						value={user ? props.user.username : ''}
						disabled={true}
					/>					

					<FormLabel>Email Address</FormLabel>
					<FormControl
						type="email"
						defaultValue={email}
						onChange={onchangeEmail}
					/>

					<br/>

					<FormGroup>
						<Alert variant="info" >
							Note: We will send you a verification link to your email address. Please check your inbox and your spam folder. 
							You will not be able to change your email address after you verify it. 
						</Alert>				
					</FormGroup>

        </Modal.Body>
        <Modal.Footer>
          <div style={{display:'flex', flexDirection:'row',flexWrap:'wrap',justifyItems:'center',alignItems:'center',gap:'50px',alignContent:'baseline'}}>
            <Button onClick={() => {props.sendVerifyEmail(email);handleClose();}} variant="primary">
              Send Verification Link
            </Button>
          </div>
        </Modal.Footer>

      </Modal>
    </>
  )
}

export default ModalVerifyEmail;

